import * as angular from "angular";

angular
  .module('bringoz.admin.commissions')
  .constant('Commissions_PN', {
    database: 'accountCommission',
    isBranchEntity: true
  });
